import { render } from "./PushNotificationPrompt.vue?vue&type=template&id=83b06784&scoped=true"
import script from "./PushNotificationPrompt.vue?vue&type=script&lang=js"
export * from "./PushNotificationPrompt.vue?vue&type=script&lang=js"

import "./PushNotificationPrompt.vue?vue&type=style&index=0&id=83b06784&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b06784"]])

export default __exports__